import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

export type TypedSupabaseClient = SupabaseClient<Database, 'almanak'>;

/** Convenience alias for table row types from the almanak schema. */
export type AlmanakTables = Database['almanak']['Tables'];

let _supabase: TypedSupabaseClient | null = null;

export function getSupabase(): TypedSupabaseClient | null {
  if (!_supabase) {
    const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
    const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
    if (!url || !key) {
      return null;
    }
    _supabase = createClient<Database, 'almanak'>(url, key, { db: { schema: 'almanak' } });
  }
  return _supabase;
}
